import scene from "./sorting-scene.png";
import styles from "./sorting-scene.module.css";

/**
 * People sorting into bins, in line art — in the corner of an empty conversation. The ground is
 * transparent, so it sits on any surface.
 */
export function SortingScene({ className }: { className?: string }) {
  return <img className={`${styles.scene} ${className ?? ""}`} src={scene} alt="" aria-hidden draggable={false} />;
}
